
import { isValidPhoneNumber } from '../utils/phoneValidation';

const validateEmail = (val: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

const validatePassword = (val: string) => val.length >= 6;

const validatePhone = (val: string) => isValidPhoneNumber(val);

export {
    validateEmail,
    validatePassword,
    validatePhone,
}